import { CHANGE_THEME } from "./actionTypes";
import { RootState } from "../store";

const initialState = {
  theme: false,
};

const ThemeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case CHANGE_THEME:
      return {
        ...state,
        theme: !state.theme,
      };

    default:
      return state;
  }
};

export default ThemeReducer;
